// Warm up: fetch wasm bytes once
import wasmAssetUrl from '@ouster/ouster-sdk-js-web/artifacts/ouster_js_web.wasm';

let wasmBytesP: Promise<ArrayBuffer> | null = null;

/**
 * Get the SDK WASM Web module bytes
 *
 * @returns Promise that resolves to the WASM bytes
 */
export function getOusterWasmBytes(): Promise<ArrayBuffer> {
  if (!wasmBytesP) {
    wasmBytesP = fetch(wasmAssetUrl).then((r) => {
      if (!r.ok) throw new Error(`WASM fetch failed: ${r.status}`);
      return r.arrayBuffer();
    });
  }
  return wasmBytesP;
}
